import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
const BlogView = React.lazy(() => import("../components/BlogView"));
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarFour = React.lazy(() => import("../components/NavbarFour"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const Blog = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarFour />

          {/* Breadcrumb */}
          <Breadcrumb title={"BLOG"} />

          {/* Blog View */}
          <BlogView />

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>
      </Fragment>
    </>
  );
};

export default Blog;
